import GoalRoute from 'cio/pods/broadcasts/broadcast/setup/goal/route';
export default GoalRoute;
